import { IHyperlink } from '../../../common/interfaces';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { Image } from '../../../common/interfaces/ViewData.interface';
import { containerLinksMapSelector } from '../../../containers/View/Report/Selectors';
import { innerCell } from './InnerCell';

interface InnerCellWrapperProps {
    displayValue: string;
    cellFormatClassNames: string[];
    symbol?: string;
    hyperlink?: IHyperlink;
    containerId: number;
    image?: Image;
}

const InnerCellWrapper: React.FC<InnerCellWrapperProps> = ({ displayValue, cellFormatClassNames, symbol, hyperlink, containerId, image }) => {
    const containerLinksMap = useSelector(containerLinksMapSelector);

    // Update container link URL if feature is enabled and container ID exists in the map
    if (hyperlink && containerLinksMap?.has(containerId)) {
        hyperlink.url = containerLinksMap.get(containerId) || '';
    }

    return <>{innerCell(displayValue, cellFormatClassNames, symbol, hyperlink, image, containerId)}</>;
};

export default InnerCellWrapper;
